import React from 'react'
import { makeStyles } from '@mui/styles'
import classNames from 'clsx'
import MUIButton from '@mui/material/Button'
import { CircularProgress } from '@mui/material'
import chroma from 'chroma-js'

const useStyles = makeStyles((theme) => ({
  Button: ({ dense }) => ({
    boxSizing: 'border-box',
    borderRadius: 3,
    fontWeight: 'bold',
    fontSize: 16,
    lineHeight: '21px',
    textTransform: 'none',
    padding: dense ? '6px 16px' : '12.5px 16px',
  }),
  disabled: {
    opacity: 0.3,
    border: 'none',
    color: theme.palette.primary.main + ' !important',
    boxShadow: '0 0 0 1px ' + theme.palette.border + '!important',
  },
  secondary: {
    background: 'rgba(0,0,0,0)',
    color: theme.palette.primary.main,
    border: 'solid 2px ' + theme.palette.primary.main,
    '&:hover': {
      background: theme.palette.secondary.main,
      boxShadow: '0 0 0 1px ' + theme.palette.secondary.main,
      color: '#FFF',
      border: 'solid 2px ' + theme.palette.secondary.main,
    },
    '&:active': {
      background: chroma(theme.palette.secondary.main).brighten(0.5).hex(),
      boxShadow: '0 0 0 1px ' + chroma(theme.palette.secondary.main).brighten(0.5).hex(),
      color: '#FFF',
      border: 'solid 2px ' + chroma(theme.palette.secondary.main).brighten(0.5).hex(),
    },
  },
  iconLeft: {
    justifyItems: 'center',
    display: 'flex',
    marginRight: 10,
  },
  iconRight: {
    justifyItems: 'center',
    display: 'flex',
    marginLeft: 10,
  },
}))

const SecondaryButton = ({
  children,
  onClick,
  variant = 'secondary',
  loading,
  className,
  dense = false,
  ...props
}) => {
  const classes = useStyles({ dense })
  return (
    <MUIButton
      {...props}
      onClick={onClick}
      disabled={props.disabled || loading}
      disableRipple
      className={classNames(
        classes.Button,
        { [classes.disabled]: props.disabled || loading },
        classes.secondary,
        className
      )}
    >
      {loading ? <CircularProgress color="primary" size={24} /> : children}
    </MUIButton>
  )
}

export default SecondaryButton
